/**
 * abilityVfxDemacianJustice — Garen R falling Demacian sword (SP-08).
 */
export function buildDemacianJustice(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.7 * (spec.scale || 1.5);
  const gold = mat(THREE, spec.color || 0xfde047, 0.92);
  const steel = mat(THREE, 0xfefce8, 0.95);
  addFallingSword(THREE, group, s, gold, steel);
  addImpact(THREE, group, s, gold);
  group.userData = { shape: 'demacian_justice' };
  return group;
}

function addFallingSword(THREE, group, s, gold, steel) {
  const blade = new THREE.Mesh(new THREE.BoxGeometry(0.18 * s, 1.6 * s, 0.08 * s), steel);
  blade.position.y = 1.4 * s;
  group.add(blade);
  const tip = new THREE.Mesh(new THREE.ConeGeometry(0.14 * s, 0.4 * s, 4), gold);
  tip.position.y = 0.5 * s;
  if (!tip.rotation) tip.rotation = { x: 0 };
  tip.rotation.x = Math.PI;
  group.add(tip);
  const hilt = new THREE.Mesh(new THREE.BoxGeometry(0.45 * s, 0.1 * s, 0.1 * s), gold);
  hilt.position.y = 2.25 * s;
  group.add(hilt);
  const column = new THREE.Mesh(new THREE.CylinderGeometry(0.06 * s, 0.12 * s, 2.2 * s, 8), gold);
  column.position.y = 1.5 * s;
  group.add(column);
}

function addImpact(THREE, group, s, gold) {
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.35, s * 0.95, 22).rotateX(-Math.PI / 2),
    gold
  );
  ring.position.y = 0.05;
  group.add(ring);
  const flash = new THREE.Mesh(new THREE.SphereGeometry(0.28 * s, 10, 10), gold);
  flash.position.y = 0.25 * s;
  group.add(flash);
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
